import BundleBreakdownModal from './BundleBreakdownModal';

export default BundleBreakdownModal;
